import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BusinessDetail } from 'src/app/entities/request';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { InteractionType, LocalService, PageKey, Status, ActiveInactiveFor, KeyValues5, RelationShipRole, CustomLabelInitialization, KeyValueSet } from 'src/service/local.service';
import { PrinterService } from 'src/service/printer.service';
import { ProductManagementService } from 'src/service/product-management.service';

@Component({
  selector: 'app-custom-print-label',
  templateUrl: './custom-print-label.component.html',
  styleUrl: './custom-print-label.component.scss'
})
export class CustomPrintLabelComponent {
  lstSectionConfigKeys: string[] = ["common", "table", "custom_label_print"];
  ctryCode: string = ''; businessId: string = ''; userId: string = ''; interactionType = 0; maxBodyHeight = 0;
  wrapper: CustomLabelInitialization; selectedLanguageId: string = '';
  isOpenCustomLabelConfig = false; selectedId = ''; isCanEdit: boolean = false;
  RelationShipRole = RelationShipRole; isShowDeleted = false; isShowOnlyPinned = true; customFields: KeyValueSet[] = [];

  tabs: KeyValueSet[] = []; selectedTabKey: string = ''; selectedItems: KeyValues5[] = [];

  elementIds: any = {
    title: 'txt_custome_label_print_title',
    value: 'txt_custome_label_print_value',
  };

  constructor(public localService: LocalService, private route: ActivatedRoute, private productManagementService: ProductManagementService, private configurationManagementService: ConfigurationManagementService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private printerService: PrinterService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.userId = routeParams.userId;
      this.configurationManagementService.ensurePageActions(PageKey.CustomPrintLabels, this.businessId);
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
        this.onLoad(true);
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight() - 20;
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onSetCustomFields();
    this.selectedLanguageId = this.localService.getSelectedLanguageId();
  }

  isProcessing = false;
  onLoad(isInitiate = false) {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      if (!this.isProcessing) {
        this.isProcessing = true;
        if (isInitiate) {
          this.printerService.getCustomLabelPrintsMinInitialization(this.localService.getLoginAsCountryCode() , this.businessId, this.selectedLanguageId, !this.isShowDeleted, this.isShowOnlyPinned).subscribe(result => {
            this.wrapper = result;
            //this.isCanEdit = this.wrapper.contents.length == 0 || this.wrapper.contents.filter(x => x.v3 == '1').length > 0;
            this.isProcessing = false;
            this.onSetTabs();
          });
        } else {
          this.printerService.getCustomLabelPrintsMin(this.localService.getLoginAsCountryCode() , this.businessId, this.selectedLanguageId, !this.isShowDeleted, this.isShowOnlyPinned).subscribe(result => {
            this.wrapper.contents = result;
            //this.isCanEdit = this.wrapper.contents.items.length == 0 || this.wrapper.contents.items.filter(x => x.v3 == '1').length > 0;
            this.isProcessing = false;
            this.onSetSelectedTabItems();
          });
        }
      }
    }
  }

  onSetTabs() {
    this.tabs = [];
    this.wrapper.contents.forEach(option => {
      this.tabs.push({
        key: option.content.v1,
        value: (option.content.v3 ?? 'N/A') + ' (' + option.items.length + ')'
      } as KeyValueSet);
    });

    if (this.tabs.length > 0) {
      this.selectedTabKey = this.tabs[0].key;
      this.onSetSelectedTabItems();
    }
  }

  onSetSelectedTabItems() {
    this.selectedItems = this.wrapper.contents.find(x => x.content.v1 == this.selectedTabKey)?.items ?? [];
  }

  onSetCustomFields() {
    this.productManagementService.getCustomFields(this.businessId, true).subscribe(result => {
      this.customFields = result.map(function (dt) {
        return {
          key: dt.key,
          value: dt.v2,
          s_value: dt.v3
        } as KeyValueSet;
      });
    });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.selectedId = key ?? '';
        this.isOpenCustomLabelConfig = true;
      } break;
    }
  }

  onActiveInactiveStatus(key: string) {
    this.printerService.activeInactiveStatus({} as BusinessDetail, key, ActiveInactiveFor.CustomLabelPrint).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
    });
  }
}
